<template>
	<div
		class="tw-uppercase tw-tracking-wider tw-text-gray-400 tw-font-medium tw-px-8 tw-text-sm tw-h-12 tw-flex tw-items-center"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'Subheader',
}
</script>
